import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
import styled from 'rn-css';

const SVG = styled(Svg)`
	cursor: pointer;
`;

const CrossIcon = (props: SvgProps) => (
	<SVG {...props}>
		<Path fill="none" d="M0 0h24v24H0z" />
		<Path d="m12 10.586 4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
	</SVG>
);

export default CrossIcon;
